import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// Bouton flottant de retour en haut de page (bas-droite), visible au défilement.
export const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      data-testid="back-to-top"
      aria-label="Remonter en haut de la page"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-50 h-12 w-12 flex items-center justify-center rounded-full bg-orange text-ink shadow-lg hover:bg-ink hover:text-orange transition-colors duration-200"
    >
      <ArrowUp size={22} strokeWidth={2.4} />
    </button>
  );
};
